import { useEffect, useMemo, useState } from 'react';

export interface ScenarioPlannerEditInputFieldComponentProps {
  placeholder?: string;
  value: string | number | string[] | undefined;
  isOverwritten: boolean;
  disabled?: boolean;
  onChange(
    fieldId: string,
    value: string | number | string[] | undefined,
  ): void;
  fieldId: string;
}

export const ScenarioPlannerEditInputFieldComponent = ({
  placeholder,
  value,
  isOverwritten,
  disabled,
  onChange,
  fieldId,
}: ScenarioPlannerEditInputFieldComponentProps) => {
  const [internalValue, setInternalValue] = useState<
    string | number | string[] | undefined
  >(value);
  useEffect(() => {
    onChange(fieldId, internalValue);
  }, [fieldId, onChange, internalValue]);
  const className = useMemo(() => {
    const classes = ['form-control'];
    if (isOverwritten) {
      classes.push('field-overwritten');
    }
    if (internalValue && value !== internalValue) {
      classes.push('field-edited');
    }
    return classes.join(' ');
  }, [isOverwritten, internalValue, value]);
  return (
    <input
      type="number"
      className={className}
      defaultValue={internalValue}
      onChange={(e) => setInternalValue(e.target.value)}
      step="0.01"
      placeholder={placeholder}
      disabled={disabled}
    />
  );
};

export default ScenarioPlannerEditInputFieldComponent;
